import flattenDeep from 'lodash/flattenDeep';
import * as React from 'react';

import { Falsy, IListOfRecursiveArraysOrValues } from '../../../types';

export function transform(values: IListOfRecursiveArraysOrValues<string | Falsy>): React.CSSProperties {
  const value = flattenDeep(values).filter(Boolean).join(' ');

  return {
    transform: value,
    WebkitTransform: value,
  };
}

export function translateX(value: number, unit: 'px' | '%' = 'px') {
  return `translate3d(${value}${unit}, 0, 0)`;
}

export function translateY(value: number, unit: 'px' | '%' = 'px') {
  return `translate3d(0, ${value}${unit}, 0)`;
}

export function scale(value: number) {
  return `scale(${value})`;
}
